import { render, staticRenderFns } from "./goodMarketNew.vue?vue&type=template&id=6614183e"
import script from "./goodMarketNew.vue?vue&type=script&lang=js"
export * from "./goodMarketNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports